import React, { useEffect, useState } from 'react'
import "./Calculator.scss";
import TextField from '@material-ui/core/TextField';
import axios from "axios";
import { apiUrl } from '../../constants';
import useQuery from '../../components/useQuery'
import useQueryApp from '../../components/useQueryApp'
import useQueryType from '../../components/useQueryType'
const CalQuotationTCO = (props) => {
    console.log(props)
    var token_get = localStorage.getItem('token')
    var cover_token_get = JSON.parse(token_get)
    const app_version = useQueryApp();
    const device_type = useQueryType();
    const [dataLifetime, setdataLifetime] = useState([])
    const [dataWorking, setdataWorking] = useState([])
    const [dataIdling, setdataIdling] = useState([])
    const [app_version_data, setapp_version] = useState(app_version)
    const [device_type_data, setdevice_type] = useState(device_type)
    useEffect(() => {
        setdataLifetime(props.datalifetime_working)
        // if(props.lifetime_working == "asd"){
        //     setdataLifetime(props.lifetime_working)
        // }else{
        //     setdataLifetime("Please select lifetime ...")
        // }
        

        setdataWorking([
            { id: 1, name: "P mode" },
            { id: 2, name: "E mode" },
        ])

        setdataIdling([
            { id: 1, name: "10" },
            { id: 2, name: "20" },
            { id: 3, name: "30 (average)" },
            { id: 4, name: "40" },
            { id: 5, name: "50" },
            { id: 6, name: "60" },
            { id: 7, name: "70" },
        ])

    }, [props.datalifetime_working])

    const selectItemLifetime = (item) => {
        props.lifetime_working_change(item)
        props.handleDisplayModalLifetime(!props.displayModalLifetime)
    }

    const selectItemWorking = (item) => {
        props.working_mode_change(item)
        props.handleDisplayModalWorking(!props.displayModalWorking)
    }

    const selectItemIdling = (item) => {
        props.idling_ratio_change(item)
        props.handleDisplayModalIdling(!props.displayModalIdling)
    }

    return (
        <div className="container">

            <fieldset className="my-fieldset" style={{ marginTop: "20px" }} onClick={() => props.handleDisplayModalLifetime(!props.displayModalLifetime)}>
                <legend className="my-legend-lifetime_working-cal-quotation-tco">
                    Lifetime working (Hour)
                    </legend>

                <div className="d-flex justify-content-between" style={{ marginBottom: "20px", marginTop: "10px" }}>
                    <span style={{ marginLeft: "10px" }}>{props.lifetime_working}</span>
                    <div style={{ marginRight: "10px" }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                        </svg>
                    </div>

                </div>
            </fieldset>

            <fieldset className="my-fieldset" style={{ marginTop: "20px" }} onClick={() => props.handleDisplayModalWorking(!props.displayModalWorking)}>
                <legend className="my-legend-working_mode-cal-quotation-tco">
                    Working mode
                    </legend>

                <div className="d-flex justify-content-between" style={{ marginBottom: "20px", marginTop: "10px" }}>
                    <span style={{ marginLeft: "10px" }}>{props.working_mode}</span>
                    <div style={{ marginRight: "10px" }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                        </svg>
                    </div>

                </div>
            </fieldset>

            <fieldset className="my-fieldset" style={{ marginTop: "20px" }} onClick={() => props.handleDisplayModalIdling(!props.displayModalIdling)}>
                <legend className="my-legend-idling_ratio-cal-quotation-tco">
                    Idling ratio (%)
                    </legend>

                <div className="d-flex justify-content-between" style={{ marginBottom: "20px", marginTop: "10px" }}>
                    <span style={{ marginLeft: "10px" }}>{props.idling_ratio}</span>
                    <div style={{ marginRight: "10px" }}>
                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.184424 11.8192C-0.0391203 11.6001 -0.0594426 11.2571 0.123458 11.0155L0.184424 10.9462L5.23006 6L0.184424 1.05377C-0.0391203 0.83462 -0.0594426 0.491687 0.123458 0.250032L0.184424 0.180798C0.407969 -0.0383512 0.75778 -0.0582738 1.00428 0.12103L1.0749 0.180798L6.56558 5.56351C6.78912 5.78266 6.80944 6.1256 6.62654 6.36725L6.56558 6.43649L1.0749 11.8192C0.829005 12.0603 0.430324 12.0603 0.184424 11.8192Z" fill="#200E32" />
                        </svg>
                    </div>

                </div>
            </fieldset>


            <div className={`Modal ${props.displayModalLifetime ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>Lifetime working (Hour)</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => props.handleDisplayModalLifetime(!props.displayModalLifetime)}
                >
                    X
                </button>
                <hr />

                {dataLifetime.length > 0 ? dataLifetime.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItemLifetime(item)}>
                            <p>{item.master_value}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>
            <div
                className={`Overlay ${props.displayModalLifetime ? "Show" : ""}`}
                onClick={() => props.handleDisplayModalLifetime(!props.displayModalLifetime)}
            />

            <div className={`Modal ${props.displayModalWorking ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>Working mode</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => props.handleDisplayModalWorking(!props.displayModalWorking)}
                >
                    X
                </button>
                <hr />

                {dataWorking.length > 0 ? dataWorking.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItemWorking(item)}>
                            <p>{item.name}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>
            <div
                className={`Overlay ${props.displayModalWorking ? "Show" : ""}`}
                onClick={() => props.handleDisplayModalWorking(!props.displayModalWorking)}
            />

            <div className={`Modal ${props.displayModalIdling ? "Show" : ""}`}>
                <div style={{ marginTop: "10px" }}>
                    <h3>Idling ratio (%)</h3>
                </div>

                <button
                    className="Close"
                    onClick={() => props.handleDisplayModalIdling(!props.displayModalIdling)}
                >
                    X
                </button>
                <hr />

                {dataIdling.length > 0 ? dataIdling.map((item, key) => {
                    return (
                        <div key={key} className="container" onClick={() => selectItemIdling(item)}>
                            <p>{item.name}</p>
                            <hr />

                        </div>
                    )
                }) : "No data"}
            </div>
            <div
                className={`Overlay ${props.displayModalIdling ? "Show" : ""}`}
                onClick={() => props.handleDisplayModalIdling(!props.displayModalIdling)}
            />

        </div>

    )
}

export default CalQuotationTCO
